import { useEffect, useRef } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What are the best Bangalore kids trips for schools?",
    a: "Open Sky Adventure Academy's AgriLearn Campus offers the top-rated Bangalore kids trips and Bangalore pre-school tours with hands-on farming, animals, and sustainability. Our programs are designed for Nursery through Grade 12 and are fully supervised and device-free.",
  },
  {
    q: "Are there curriculum-aligned school trips in Bangalore?",
    a: "Yes-our Bangalore school tours, Bangalore school guided tours, and Bangalore school learning trips are meticulously mapped to CBSE, ICSE, IGCSE, IB & Karnataka State Board curricula. Detailed lesson plans and teacher guides are available on request.",
  },
  {
    q: "Where are the best Bangalore pre-school tours located?",
    a: "Just a short drive from Bengaluru at our 7.5-acre AgriLearn Campus-safe, supervised, and perfect for Nursery to KG. Children engage with farm animals, explore plant life, and experience the magic of nature firsthand.",
  },
  {
    q: "What safety measures are in place during the programs?",
    a: "We maintain a strict 1:20 staff-to-student ratio, have professionally trained facilitators, on-site first aid stations, comprehensive emergency protocols, and full liability insurance. Pre-visit campus safety walkthroughs are available for principals and trustees.",
  },
  {
    q: "How does the booking process work?",
    a: "Submit an inquiry through our form, and we respond within 2 hours. Once confirmed, we handle everything-transportation, curated meals, safety protocols, insurance, trained facilitators, and post-visit impact reports. Schools simply need to provide a letter of intent and student ID cards.",
  },
  {
    q: "What boards and curricula do your programs align with?",
    a: "Our programs are aligned with CBSE, ICSE, Karnataka State Board, IGCSE, and IB curricula. Every module is designed in consultation with educators to complement academic standards while delivering experiential learning outcomes.",
  },
  {
    q: "Can multiple grade levels participate in the same visit?",
    a: "Absolutely. Our programs are modularized and scalable for every grade level-from Nursery through Grade 12. Content depth and activities are calibrated to the physical and cognitive capabilities of each age group.",
  },
  {
    q: "What is included in the program pricing?",
    a: "All costs are inclusive with no hidden charges. Programs include full day access, activities, course certificates, photographs (group and individual), a virtual album, and social media features. Transportation and meals may be included depending on the package chosen.",
  },
];

export default function FAQSection() {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) entry.target.classList.add("visible"); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="faq" data-testid="faq-section" ref={ref} className="reveal-section py-16 md:py-20 bg-muted/50">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-accent mb-4">
            Frequently Asked Questions
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-foreground">
            Common Questions Answered
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-card border border-border/60 px-6 rounded-sm"
            >
              <AccordionTrigger className="font-heading text-base sm:text-lg font-medium text-foreground text-left py-5 hover:no-underline hover:text-primary transition-colors">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground font-light leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
